import {
  type SerializedCompStructure,
  type SerializedPageStructure,
} from '@wix/document-services-types'

import { type DataBindingControllerConnection } from '../types'
import {
  assertDataBindingController,
  assertNonNullable,
  breakDownControllerConnectionsToComponent,
  getComponentByVeloId,
  getVeloIdOf,
} from '../utils'
import { FIELD_STACK_VELO_ID } from './veloIds'
import { ROUTER_DATASET_VELO_ID } from '../veloIds'

export const breakDownFieldTemplates = (
  page: SerializedPageStructure,
): {
  templateComponentByVeloId: { [VeloId: string]: SerializedCompStructure }
  templateControllerConnectionsByVeloId: {
    [VeloId: string]: DataBindingControllerConnection[]
  }
  connectedTemplateComponentIds: string[]
} => {
  const fieldStack = getComponentByVeloId({
    root: page,
    veloId: FIELD_STACK_VELO_ID,
  })
  assertNonNullable(fieldStack.components)

  const routerDataset = getComponentByVeloId({
    root: page,
    veloId: ROUTER_DATASET_VELO_ID,
  })
  assertDataBindingController(routerDataset)

  return fieldStack.components.reduce<
    ReturnType<typeof breakDownFieldTemplates>
  >(
    (
      {
        templateComponentByVeloId,
        templateControllerConnectionsByVeloId,
        connectedTemplateComponentIds,
      },
      component,
    ) => {
      assertNonNullable(component.id)
      const veloId = getVeloIdOf(component)
      const connectionBreakdown = breakDownControllerConnectionsToComponent({
        controller: routerDataset,
        component,
      })
      return {
        templateComponentByVeloId: {
          ...templateComponentByVeloId,
          [veloId]: component,
        },
        templateControllerConnectionsByVeloId: {
          ...templateControllerConnectionsByVeloId,
          ...connectionBreakdown.controllerConnectionsByVeloId,
        },
        connectedTemplateComponentIds: [
          ...connectedTemplateComponentIds,
          ...connectionBreakdown.connectedComponentIds,
        ],
      }
    },
    {
      templateComponentByVeloId: {},
      templateControllerConnectionsByVeloId: {},
      connectedTemplateComponentIds: [],
    },
  )
}
